// @flow

import * as React from 'react';

import type { Currency } from '@gandi/billing';
import { AddressField } from '@gandi/react-places';
import type {
  CreateOneOrganizationAction,
  CreateData,
} from '@gandi/redux-organization';
import type { TranslatorProps } from '@gandi/translate';

import { SubmissionError } from 'gandi.react-form';

import type {
  PreFetchArgs,
  PreFetchReturn,
  WithRouterProps,
  AnyQuery,
} from 'src/types';

import AccountForm from '../../components/Form';
import type { InitialValuesProps } from '../../components/Form/AccountForm';

export type StateProps = {
  currencies: Array<Currency>,
  hasOwnerOnly: boolean,
  cartId: string,
};

export type DispatchProps = {
  createOneOrganization: CreateOneOrganizationAction,
  destroyForm: () => mixed,
};

export type OwnProps = {
  ...WithRouterProps<
    {
      cartId: string,
    },
    { ...AnyQuery, ... },
  >,
};

export type InjectedProps = {
  translator: TranslatorProps,
};

type Props = {
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
  ...InjectedProps,
};

class Presenter extends React.Component<Props> {
  static preFetch(args: PreFetchArgs<>): PreFetchReturn<> {
    // TODO: check this preFetch still make sens
    // AddressField.preFetch is based on the bu and the country
    // does it make sens for new Account?
    return AddressField.preFetch(args);
  }

  destroyOnUnmount: boolean = true;

  componentWillUnmount() {
    if (this.destroyOnUnmount) {
      this.props.destroyForm();
    }
  }

  handleSubmit: any => Promise<void | any> = ({
    id,
    ...data
  }: {
    id: number,
    ...CreateData,
  }) => {
    const {
      cartId,
      location: {
        query: { owner = 'cart' },
      },
      translator: { __ },
    } = this.props;

    this.destroyOnUnmount = false;

    return (
      this.props
        // $FlowFixMe[incompatible-call]
        .createOneOrganization(data, { dryrun: true })
        // $FlowFixMe[prop-missing]
        .then(() => {
          this.props.navigate(
            `/cart/${cartId}/configure/account-choice/confirm/organization/new?owner=${owner}`,
          );
        })
        .catch(err => {
          this.destroyOnUnmount = true;

          if (err.errors) {
            throw new SubmissionError(err.errors);
          } else if (err.originalError) {
            throw new SubmissionError(err.originalError.errors);
          } else {
            throw new SubmissionError({
              _error: __(
                'Unable to save account information. Please try again later.',
              ),
            });
          }
        })
    );
  };

  isFirstBuy(): boolean {
    return 'first' in this.props.location.query;
  }

  render(): React.Node {
    const initialValues: InitialValuesProps = {
      // $FlowFixMe[incompatible-type] `AnyQuery` type is poisoning the actual `type` arg for this page with the `type` used in create cert
      type: this.props.location.query.type || 'company',
    };

    return (
      <AccountForm
        cartId={this.props.params.cartId}
        hasOwnerOnly={this.props.hasOwnerOnly}
        canChangeCurrency
        currencies={this.props.currencies}
        initialValues={initialValues}
        destroyOnUnmount={false}
        forceUnregisterOnUnmount
        onTypeChange={
          this.isFirstBuy()
            ? () => {
                this.destroyOnUnmount = false;
              }
            : undefined
        }
        isCreation
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default Presenter;
